import { useEffect, useState } from "react";

import { getMailboxes } from "../api/mailboxApi";

// One lookup per page load, shared by every email link on the page.
let canSendPromise = null;

export function resetMailboxCanSend() {
  canSendPromise = null;
}

/** Whether the signed-in agent can send from their own connected Gmail. */
export default function useMailboxCanSend() {
  const [canSend, setCanSend] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!canSendPromise) {
      canSendPromise = getMailboxes()
        .then((d) => Boolean(d?.can_send))
        .catch(() => false);
    }
    canSendPromise.then((v) => {
      if (alive) setCanSend(v);
    });
    return () => {
      alive = false;
    };
  }, []);

  return canSend;
}
